var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7581 3.43467C21.106 2.19623 19.3361 2.18643 18.6703 3.41757L2.71662 32.9192C2.08608 34.0852 2.93039 35.5017 4.25595 35.5017H35.7435C37.0606 35.5017 37.9056 34.1017 37.292 32.9363L21.7581 3.43467ZM16.4713 2.22838C18.0881 -0.761525 22.3866 -0.737728 23.9702 2.26991L39.5041 31.7716C40.9943 34.6017 38.942 38.0017 35.7435 38.0017H4.25595C1.03672 38.0017 -1.01374 34.5617 0.517565 31.73L16.4713 2.22838ZM20 11C20.6904 11 21.25 11.5596 21.25 12.25V23.75C21.25 24.4404 20.6904 25 20 25C19.3096 25 18.75 24.4404 18.75 23.75V12.25C18.75 11.5596 19.3096 11 20 11ZM20 31C21.1046 31 22 30.1046 22 29C22 27.8954 21.1046 27 20 27C18.8954 27 18 27.8954 18 29C18 30.1046 18.8954 31 20 31Z",
    fill: "#C40233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f4750b12c856835c3883a8d8de598d16.svg";
export { ForwardRef as ReactComponent };